import { AlertTriangle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { WageLevel } from "@api/shared-runtime/enums";
import { formatWage } from "../../../utils/custom-wage";
import type { OrgPendingTimeEntry } from "../../hooks/usePendingTimeEntries";

interface WageSummaryProps {
  entry: Pick<OrgPendingTimeEntry, "wage" | "organizationWageSet">;
}

/** What approval will pay per unit, with the wage set and any custom wage shown, and gaps called out. */
export function WageSummary({ entry }: WageSummaryProps) {
  if (!entry.wage) {
    return (
      <div
        role="alert"
        className="flex items-start gap-1.5 rounded-md border border-red-200 bg-red-50 px-2 py-1 text-xs text-red-700"
      >
        <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
        <span>
          There is no standard wage for this wage type, so approval will fail.
          Edit the wage or reject the entry.
        </span>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="whitespace-nowrap text-sm font-semibold text-slate-900">
        {formatWage(entry.wage)}
      </span>
      {entry.organizationWageSet && (
        <Badge variant="secondary" className="max-w-full truncate text-xs">
          {entry.organizationWageSet.name}
        </Badge>
      )}
      {entry.wage.level === WageLevel.Custom && (
        <Badge
          variant="outline"
          className="border-amber-200 bg-amber-50 text-xs text-amber-800"
        >
          Custom wage
        </Badge>
      )}
    </div>
  );
}
